export default {
  palette: {
    type: 'light',
    common: {
      white: '#FFF',
      black: '#000',
      paleOrange: '#FCF7E9',
      mediumGreen: '#1B3642',
    },
    background: {
      default: '#F6FAFD',
    },
    primary: {
      main: '#00B7C1',
      light: '#54BFC8',
      dark: '#01A8B1',
      contrastText: '#fff',
      100: '#00A5AE',
      200: '#00929A',
      300: '#008087',
      400: '#006E74',
      500: '#005C61',
      600: '#00494D',
      700: '#00373A',
      800: '#002527',
      900: '#001213',
    },
    secondary: {
      main: '#1E3641',
      contrastText: '#fff',
      100: '#F2FBFC',
      200: '#E6F8F9',
      300: '#CCF1F3',
      400: '#B3E9EC',
      500: '#99E2E6',
      600: '#80DBE0',
      700: '#66D4DA',
      800: '#4DCDD4',
      900: '#33C5CD',
      1000: '#1ABEC7',
    },
    success: {
      main: '#00CAA6',
      light: '#E8F8ED',
      100: '#f2fcf3',
      200: '#E7F6F9',
      500: '#B4E7C6',
      800: '#2D444F',
    },
    warning: {
      main: '#E5A923',
      light: '#FFF8E9',
      100: '#FDFAF4',
      200: '#FCF6E9',
      300: '#FAEED3',
      400: '#F7E5BD',
      500: '#FFE5BF',
      600: '#F2D491',
      700: '#EFCB7B',
      800: '#EDC365',
      900: '#EABA4F',
      1000: '#E8B239',
    },
    info: {
      main: '#4173B0',
      light: '#E3F5FB',
      100: '#F6FAFD',
      500: '#ACDDF6',
      700: '#B4F0FF',
      800: '#80BAE2',
    },
    error: {
      main: '#d34343',
      light: '#FFECE9',
      100: '#FFDDDD',
      500: '#FEC9C1',
      800: '#F35454',
    },
    grey: {
      50: '#FDFDFD',
      100: '#FAFAFB',
      200: '#F3F4F5',
      300: '#E6E8EB',
      400: '#DADDE0',
      500: '#CDD1D6',
      600: '#C1C6CC',
      700: '#B4BBC2',
      800: '#A8AFB8',
      900: '#9BA4AD',
      1000: '#8F98A3',
      1100: '#828D99',
    },
    action: {
      hover: '#FCF6E9',
      selected: '#FAEED3',
      selectedDark: '#106E78',
    },
    selectPanel: {
      default: {
        backgroundColor: '#FCFCFC',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#E9F0F5',
        borderRadius: '4px',
        boxShadow: 'none !important',
      },
      selected: {
        backgroundColor: '#F2FCFC',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#D8F0F1',
        borderRadius: '4px',
        boxShadow: 'none !important',
      },
    },
    datePicker: {
      selectedHoverBorder: '#EDC365',
    },
  },
  typography: {
    fontFamily: ['Rubik'],
    h1: {
      fontSize: '24px',
      fontWeight: 500,
      lineHeight: 'inherit',
    },
    h2: {
      fontSize: '20px',
      fontWeight: 500,
    },
    h3: {
      fontSize: '18px',
      fontWeight: 500,
    },
    h4: {
      fontSize: '18px',
    },
    h5: { fontSize: '16px', fontWeight: 500 },
    h6: {
      fontSize: '12px',
    },
    body1: {
      fontSize: '13px',
    },
    body2: {
      fontSize: '12px',
    },
    button: {
      textTransform: 'none',
    },
    subtitle1: {
      fontSize: '11px',
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 500,
    },
    subtitle3: {
      fontSize: '16px',
    },
  },
};
